import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { motion } from 'framer-motion'; // 🌀 import motion

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [isAdmin, setIsAdmin] = useState(false); // Default to User Login
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const endpoint = isAdmin ? '/auth/admin/login' : '/auth/user/login';

    try {
      const response = await axios.post(endpoint, formData);
      alert(response.data.message);

      localStorage.setItem('accessToken', response.data.accessToken);
      localStorage.setItem('refreshToken', response.data.refreshToken);

      navigate(isAdmin ? '/admin/dashboard' : '/user/home');
      setFormData({ email: '', password: '' });
    } catch (err) {
      alert(err.response?.data?.message || 'Login failed. Try again!');
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <motion.div
        className="card p-4 shadow-lg border-0 rounded-4"
        style={{ width: '400px' }}
        initial={{ opacity: 0, y: 40, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        {/* Logo */}
        <motion.div
          className="text-center mb-4"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
        >
          <img src="https://timehouse.store/logo-red.svg" alt="Logo" width="150" />
        </motion.div>

        <motion.h3
          className="text-center mb-3 fw-bold"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {isAdmin ? 'Admin Login' : 'User Login'}
        </motion.h3>

        <form onSubmit={handleSubmit}>
          <motion.div
            className="mb-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <label className="form-label fw-semibold">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-control rounded-3"
              required
            />
          </motion.div>

          <motion.div
            className="mb-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-control rounded-3"
              required
            />
          </motion.div>

          <motion.button
            type="submit"
            className="btn btn-danger w-100 fw-bold rounded-3"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ duration: 0.2 }}
          >
            {isAdmin ? 'Login as Admin' : 'Login'}
          </motion.button>

          {/* Switch to Admin/User */}
          <motion.div
            className="text-center mt-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <button
              type="button"
              className="btn btn-link text-danger fw-bold"
              onClick={() => setIsAdmin(!isAdmin)}
            >
              Switch to {isAdmin ? 'User' : 'Admin'} Login
            </button>
          </motion.div>

          {/* Signup Option */}
          <motion.div
            className="text-center mt-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7 }}
          >
            <span className="text-muted">Don't have an account? </span>
            <a href="/register" className="text-danger fw-bold">
              Sign Up
            </a>
          </motion.div>
        </form>
      </motion.div>
    </div>
  );
};

export default Login;
